module.exports = __webpack_public_path__ + "static/media/dots.eb9dc74e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/icons/dots.svg
 ** module id = 377
 ** module chunks = 0
 **/